import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectAwards, changeAwards } from "lib/redux/resumeSlice";
import type { ResumeAward } from "lib/redux/types";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const AwardsForm = () => {
  const awards = useAppSelector(selectAwards);
  const dispatch = useAppDispatch();
  const showDelete = awards.length > 1;

  return (
    <Form form="awards" addButtonText="Add Award">
      {awards.map((item, idx) => {
        const { award, issuer, descriptions } = item;
        const handleAwardChange = (
          ...[field, value]: CreateHandleChangeArgsWithDescriptions<ResumeAward>
        ) => {
          dispatch(changeAwards({ idx, field, value } as any));
        };
        const showMoveUp = idx !== 0;
        const showMoveDown = idx !== awards.length - 1;

        return (
          <FormSection
            key={item.id ?? idx}
            form="awards"
            idx={idx}
            showMoveUp={showMoveUp}
            showMoveDown={showMoveDown}
            showDelete={showDelete}
            deleteButtonTooltipText={"Delete Award"}
          >
            <Input
              name="award"
              label="Award Title"
              placeholder="GSoc Contributor"
              value={award}
              onChange={handleAwardChange}
              labelClassName="col-span-4"
            />
            <Input
              name="issuer"
              label="Issuer"
              placeholder="Google"
              value={issuer}
              onChange={handleAwardChange}
              labelClassName="col-span-4"
            />
            {/* <RichEditor
              name="descriptions"
              value={descriptions}
              onChange={handleAwardChange}
              labelClassName="col-span-full"
              placeholder="Description"
            /> */}
            <RichEditorWithSuggestions
              name="descriptions"
              value={descriptions}
              onChange={handleAwardChange}
              placeholder="Description"
              section="awards"
            />
          </FormSection>
        );
      })}
    </Form>
  );
};
